const callApi = async (
  endpoint,
  method = "GET",
  data = null,
  stringifyData = true,
  auth_required = true,
  setAlertMessage,
  headers = {
    "Content-Type": "application/json",
  }
) => {
  if (auth_required) {
    if (headers === null || headers === undefined) headers = {};
    headers["Authorization"] = `Bearer ` + localStorage.getItem("token");
  }

  try {
    const options = {
      method,
      headers: headers,
    };

    if (data) {
      options.body = stringifyData ? JSON.stringify(data) : data;
    }

    const response = await fetch(
      `${process.env.REACT_APP_API}${endpoint}`,
      options
    );

    if (!response.ok) {
      const errorData = await response.json();
      if (response.status !== 401) {
        if (setAlertMessage) {
          setAlertMessage(
            errorData.message ? errorData.message : errorData.title
          );
        }
        return { body: null, success: false, message: errorData.message };
      }
      return { body: null, success: true, message: "" };
    }

    return await response.json();
  } catch (error) {
    console.log(error)
    // setAlertMessage(error);
    // if (setAlertMessage) {
    //   setAlertMessage(error);
    // }
    return { body: null, success: false, message: error };
  }
};

export default callApi;
